/* ─────────────────────────────────────────────────────────────
   Sipfull Format Thumbnails — click-swap + broken image cleanup
   -----------------------------------------------------------
   Loaded once per page via theme.liquid, instead of inlined
   in every product card. Runs deferred (after HTML parse).

   Snippet: snippets/sipfull-format-thumbs.liquid
   Task ref: #56 (performance follow-up)
   ───────────────────────────────────────────────────────── */

(function() {
  if (window.__sipfullFormatsInit) return;
  window.__sipfullFormatsInit = true;

  // ─── Broken-image cleanup ───
  // Shopify's file_url filter returns a URL with a fake version (e.g.
  // ?v=14228) even when the file doesn't exist, so the img loads and
  // 404s. The onerror on each img removes the broken thumb, and this
  // cleanup pass hides the whole row if nothing survives.
  window.__sipfullCleanupThumbs = function() {
    document.querySelectorAll('.sipfull-formats').forEach(function(row) {
      if (!row.querySelector('.sipfull-formats__thumb')) {
        row.style.display = 'none';
      }
    });
  };
  // Run once on DOM ready so any early errors get swept up
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.__sipfullCleanupThumbs);
  } else {
    setTimeout(window.__sipfullCleanupThumbs, 100);
    setTimeout(window.__sipfullCleanupThumbs, 500);
  }

  // Only intercept clicks on PHOTO thumbs (mode 1). Icon chips (mode 2)
  // are just plain links — let the browser navigate normally.
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('[data-sipfull-thumb]');
    if (!thumb) return;
    e.preventDefault();
    e.stopPropagation();

    var card = thumb.closest('.product-block');
    if (!card) return;

    var newSrc = thumb.getAttribute('data-img-src');
    var newSrcset = thumb.getAttribute('data-img-srcset');
    var variantId = thumb.getAttribute('data-variant-id');
    var productUrl = thumb.getAttribute('data-product-url');

    var primaryImages = card.querySelectorAll(
      '.product-block__image--primary img, ' +
      '.product-block__image--active img'
    );
    primaryImages.forEach(function(img) {
      if (newSrc) img.src = newSrc;
      if (newSrcset) img.srcset = newSrcset;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });

    if (productUrl && variantId) {
      var newHref = productUrl + '?variant=' + variantId;
      card.querySelectorAll('a.product-link').forEach(function(link) {
        link.href = newHref;
      });
    }

    card.querySelectorAll('[data-sipfull-thumb]').forEach(function(t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  }, true);
})();
